// How interface elements appear, disappear or change state
export const UI_TRANSITION = '250ms ease';
